var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ConfigPage',[_c('ConfigItem',{attrs:{"title":"Companhias"}},[_c('v-card',{attrs:{"outlined":"","loading":_vm.loading}},[_c('v-list',_vm._l((_vm.insurers),function(insurer){return _c('v-list-item',{key:insurer.id,staticClass:"primary--text",attrs:{"link":"","to":{
            name: 'configs.insurers_portal.show',
            params: {
              id: insurer.id,
            },
          }}},[_c('v-list-item-content',[_c('v-list-item-title',{domProps:{"textContent":_vm._s(insurer.name)}})],1),_c('v-list-item-action',[_c('v-icon',[_vm._v("mdi-chevron-right")])],1)],1)}),1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }